import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Grid,
  ButtonGroup,
  Button
} from '@mui/material';

import ListItem from './components/ListItem';
// Actions
import { getOrders } from 'actions/orderActions';
import Page from '../../components/Page/Page';


const OrderList = ({ orders, requestOrders }) => {
  const [page, setPage] = useState(1);

  useEffect(() => {
    requestOrders(page);
  }, [requestOrders, page]);

  return (
    <Page style={{
      padding: '24px'
    }}>
      <Grid
        container
        style={{margin: '8px'}}
        spacing={1}
        direction="column"
        alignItems="center">
        <Grid item>
          <Paper>
            <ButtonGroup>
              <Button
                onClick={() => {
                  if (page > 1) {
                    setPage(page - 1);
                  }
                }}>
                &#x3C;
              </Button>
              <Button>{page}</Button>
              <Button onClick={() => setPage(page + 1)}>&#x3E;</Button>
            </ButtonGroup>
          </Paper>
        </Grid>
      </Grid>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>Order ID</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Modified</TableCell>
              <TableCell>Basket</TableCell>
              <TableCell>Provider</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map(order => (
              <ListItem order={order} key={order.id} />
            ))}
          </TableBody>
        </Table>
      </Paper>
      <Grid
        container
        style={{margin: '8px'}}
        spacing={1}
        direction="column"
        alignItems="center">
        <Grid item>
          <Paper>
            <ButtonGroup>
              <Button
                onClick={() => {
                  if (page > 1) {
                    setPage(page - 1);
                  }
                }}>
                &#x3C;
              </Button>
              <Button>{page}</Button>
              <Button onClick={() => setPage(page + 1)}>&#x3E;</Button>
            </ButtonGroup>
          </Paper>
        </Grid>
      </Grid>
    </Page>
  );
};

const mapStateToProps = state => ({
  orders: state.orders.list
});

const mapDispatchToProps = dispatch => ({
  requestOrders: page => dispatch(getOrders(page))
});

OrderList.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object),
  requestOrders: PropTypes.func.isRequired
};

OrderList.defaultProps = {
  orders: []
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);
